import React, { useEffect, useState } from 'react';

const useHandleCloseDropdownMenu = (wrapperRef) => {
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useState(false);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpenDropdownMenu && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenDropdownMenu(false);
            }
        };
        const keyPressHandler = (e) => {
            if (e.keyCode === 27 && isOpenDropdownMenu) {
                setOpenDropdownMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', keyPressHandler);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', keyPressHandler);
        };
    }, [isOpenDropdownMenu]);
    return [isOpenDropdownMenu, setOpenDropdownMenu];
};
export { useHandleCloseDropdownMenu };
